/**
 * scroll-reveal.js — Faber Maison Shopify Theme
 *
 * Intersection Observer–based scroll animations.
 * Watches elements with: .reveal, .reveal-fade, .reveal-scale
 * Adds .is-visible when element enters viewport.
 */

(function () {
  'use strict';

  // Respect prefers-reduced-motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    // Show everything immediately
    document.querySelectorAll('.reveal, .reveal-fade, .reveal-scale').forEach((el) => {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: '0px 0px -60px 0px',
      threshold: 0.08,
    }
  );

  function observeAll() {
    document.querySelectorAll('.reveal, .reveal-fade, .reveal-scale').forEach((el) => {
      observer.observe(el);
    });
  }

  // Initial observation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // Re-observe after dynamic content changes (e.g. cart drawer re-render)
  window.FaberReveal = { refresh: observeAll };

})();
